import { CheckCircle } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import React from 'react';

import { useTranslationByKey } from '../../../helpers/useTranslationByKeys';
import { TranslationKey } from '../../../models';

interface ThanksProps {
    contactToUser: string;
}

const Root = styled('div')(({ theme }) => ({
    display: 'block',
    minHeight: '60px',
    '.ori-icon::before': {
        position: 'absolute',
        right: '1px',
        bottom: '-55px',
        [theme.breakpoints.up('sm')]: {
            position: 'static',
            lineHeight: theme.typography.pxToRem(50),
        },
    },
}));
const IconWrap = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(58),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(73),
    },
}));
const Header = styled('h2')(({ theme }) => ({
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(20),
    lineHeight: theme.typography.pxToRem(20),
    marginBottom: theme.spacing(3),
}));
const TextInfo = styled('p')(({ theme }) => ({
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(19),
    margin: 0,
    paddingBottom: theme.spacing(1),
}));

export const Thanks: React.FC<ThanksProps> = ({ contactToUser }) => {
    const t = useTranslationByKey();

    return (
        <Root>
            <IconWrap>
                <CheckCircle fontSize="inherit" />
            </IconWrap>
            <Header>{t(TranslationKey.thankYou)}</Header>
            <TextInfo>{t(TranslationKey.notifyMeSuccess, { 0: contactToUser })}</TextInfo>
        </Root>
    );
};
